import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { LogoBlack } from '../common/icons/Logos';

const AuthContainer = props => {
  return (
    <div className="auth-container">
      <div className="auth-container-body">
        <Link to="/" className="auth-container-logo">
          <LogoBlack />
        </Link>

        <div className="is-fullwidth">{props.children}</div>
      </div>
    </div>
  );
};

AuthContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContainer;
